// no itx for this file

export default class DPTXlator {
  // conversion Logic imported from Calimero's DPTXlator
  // Most function Outputs are in Uint8Array Format
  // Some functions directly manipulate buffer

  // DPT-1: Boolean
  // DPT-2: 1-Bit controlled (2 bits - Control,Value)
  // DPT-3: 3 Bit Controlled
  // (Not Implemented) DPT-4: Character Set (ASCII, 8859_1)
  // DPT-5: 8 Bit Unsigned
  // DPT-6: 8 Bit Signed
  // DPT-7: 2 Byte Unsigned
  // DPT-8: 2 Byte Signed
  // DPT-9: 2 Byte Float
  // DPT-10: Time
  // DPT-11: Date
  // DPT-12: 4 Byte Unsigned
  // DPT-13: 4 Byte Signed
  // DPT-14: 4 Byte Float  (Uses IEEE-754 Encoding)
  // DPT-16: String
  // DPT-17: Scene Number
  // DPT-18: Scene Control
  // DPT-19: DateTime
  // DPT-28: UTF-8
  // DPT-29: 64 Bit Signed (Electrical Energy)

  // (Not Implemented) DPT-229: Metering Value
  // DPT-232: RGB Color
  // (Not Implemented) DPT-242: Color XyY
  // (Not Implemented) DPT-243: XyYTransition
  // (Not Implemented) DPT-249: Brightness & color temperature transition
  // DPT-250: Brightness & color temperature control;
  // (Not Implemented) DPT-251: Color Rgbw
  // (Not Implemented) DPT-252: RelativeControlRgbw
  // (Not Implemented) DPT-253: RelativeControlXyY
  // (Not Implemented) DPT-254: RelativeControlRgb

  ///////////////////////////////////////
  ///////////////////////////////////////
  // DPT-1: Boolean

  // DPT_SWITCH = new DPT("1.001", "Switch", "off", "on");
  // DPT_BOOL = new DPT("1.002", "Boolean", "false", "true");
  // DPT_ENABLE = new DPT("1.003", "Enable", "disable", "enable");
  // DPT_RAMP = new DPT("1.004", "Ramp", "no ramp", "ramp");
  // DPT_ALARM = new DPT("1.005", "Alarm", "no alarm", "alarm");
  // DPT_BINARYVALUE = new DPT("1.006", "Binary value", "low", "high");
  // DPT_STEP = new DPT("1.007", "Step", "decrease", "increase");
  // DPT_UPDOWN = new DPT("1.008", "Up/Down", "up", "down");
  // DPT_OPENCLOSE = new DPT("1.009", "Open/Close", "open", "close");
  // DPT_START = new DPT("1.010", "Start", "stop", "start");
  // DPT_STATE = new DPT("1.011", "State", "inactive", "active");
  // DPT_INVERT = new DPT("1.012", "Invert", "not inverted", "inverted");
  // DPT_DIMSENDSTYLE = new DPT("1.013", "Dim send-style", "start/stop", "cyclic");
  // DPT_INPUTSOURCE = new DPT("1.014", "Input source", "fixed", "calculated");
  // DPT_RESET = new DPT("1.015", "Reset", "no action", "reset");
  // DPT_ACK = new DPT("1.016", "Acknowledge", "no action", "acknowledge");
  // DPT_TRIGGER = new DPT("1.017", "Trigger", "trigger", "trigger");
  // DPT_OCCUPANCY = new DPT("1.018", "Occupancy", "not occupied", "occupied");
  // DPT_WINDOW_DOOR = new DPT("1.019", "Window/Door", "closed", "open");
  // DPT_LOGICAL_FUNCTION = new DPT("1.021", "Logical function", "OR", "AND");
  // DPT_SCENE_AB = new DPT("1.022", "Scene A/B", "scene A", "scene B");
  // DPT_SHUTTER_BLINDS_MODE = new DPT("1.023", "Shutter/Blinds mode", "only move up/down", "move up/down + step-stop");
  // DptDayNight = new DPT("1.024", "day/night", "day", "night");
  // DPT_HEAT_COOL = new DPT("1.100", "Heat/Cool", "cooling", "heating");
  // DPT_CONSUMER_PRODUCER = new DPT("1.1200", "Consumer/Producer", "consumer", "producer");
  // DPT_ENERGY_DIRECTION = new DPT("1.1201", "Energy direction", "positive", "negative");

  static toDPT1_Boolean(value, dpt) {
    const dptLookup = {
      "1.001": { lower: "off", upper: "on" },
      "1.002": { lower: "false", upper: "true" },
      "1.003": { lower: "disable", upper: "enable" },
      "1.004": { lower: "no ramp", upper: "ramp" },
      "1.005": { lower: "no alarm", upper: "alarm" },
      "1.006": { lower: "low", upper: "high" },
      "1.007": { lower: "decrease", upper: "increase" },
      "1.008": { lower: "up", upper: "down" },
      "1.009": { lower: "open", upper: "close" },
      "1.010": { lower: "stop", upper: "start" },
      "1.011": { lower: "inactive", upper: "active" },
      "1.012": { lower: "not inverted", upper: "inverted" },
      "1.013": { lower: "start/stop", upper: "cyclic" },
      "1.014": { lower: "fixed", upper: "calculated" },
      "1.015": { lower: "no action", upper: "reset" },
      "1.016": { lower: "no action", upper: "acknowledge" },
      "1.017": { lower: "trigger", upper: "trigger" },
      "1.018": { lower: "not occupied", upper: "occupied" },
      "1.019": { lower: "closed", upper: "open" },
      "1.021": { lower: "OR", upper: "AND" },
      "1.022": { lower: "scene A", upper: "scene B" },
      "1.023": { lower: "only move up/down", upper: "move up/down + step-stop" },
      "1.024": { lower: "day", upper: "night" },
      "1.100": { lower: "cooling", upper: "heating" },
      "1.1200": { lower: "consumer", upper: "producer" },
      "1.1201": { lower: "positive", upper: "negative" },
    };

    // Lookup the DPT type
    const dptValues = dptLookup[dpt];

    if (!dptValues) {
      throw new Error(`Unknown DPT type: ${dpt}`);
    }

    // Check if value matches lower or upper state
    if (dptValues.lower.toLowerCase() === value.toLowerCase()) {
      return new Uint8Array([0]);
    } else if (dptValues.upper.toLowerCase() === value.toLowerCase()) {
      return new Uint8Array([1]);
    } else {
      throw new Error(`Translation error, value not recognized: ${value}`);
    }
  }

  static fromDPT1_Boolean(bytes: Uint8Array, dpt: string): string {
    const dptLookup = {
      "1.001": { lower: "off", upper: "on" },
      "1.002": { lower: "false", upper: "true" },
      "1.003": { lower: "disable", upper: "enable" },
      "1.004": { lower: "no ramp", upper: "ramp" },
      "1.005": { lower: "no alarm", upper: "alarm" },
      "1.006": { lower: "low", upper: "high" },
      "1.007": { lower: "decrease", upper: "increase" },
      "1.008": { lower: "up", upper: "down" },
      "1.009": { lower: "open", upper: "close" },
      "1.010": { lower: "stop", upper: "start" },
      "1.011": { lower: "inactive", upper: "active" },
      "1.012": { lower: "not inverted", upper: "inverted" },
      "1.013": { lower: "start/stop", upper: "cyclic" },
      "1.014": { lower: "fixed", upper: "calculated" },
      "1.015": { lower: "no action", upper: "reset" },
      "1.016": { lower: "no action", upper: "acknowledge" },
      "1.017": { lower: "trigger", upper: "trigger" },
      "1.018": { lower: "not occupied", upper: "occupied" },
      "1.019": { lower: "closed", upper: "open" },
      "1.021": { lower: "OR", upper: "AND" },
      "1.022": { lower: "scene A", upper: "scene B" },
      "1.023": { lower: "only move up/down", upper: "move up/down + step-stop" },
      "1.024": { lower: "day", upper: "night" },
      "1.100": { lower: "cooling", upper: "heating" },
      "1.1200": { lower: "consumer", upper: "producer" },
      "1.1201": { lower: "positive", upper: "negative" },
    };

    const dptValues = dptLookup[dpt];

    if (!dptValues) {
      throw new Error(`Unknown DPT type: ${dpt}`);
    }

    if (bytes.length !== 1) {
      throw new Error(`Invalid DPT1 buffer length: expected 1 byte`);
    }

    const bit = bytes[0] & 0x01;

    return bit === 0 ? dptValues.lower : dptValues.upper;
  }

  ///////////////////////////////////////
  // DPT-2: 1-Bit controlled (2 bits - Control,Value)

  // DPT_SWITCH_CONTROL = new DPT1BitControlled("2.001","Switch Controlled", DPTXlatorBoolean.DPT_SWITCH);
  // DPT_BOOL_CONTROL = new DPT1BitControlled("2.002", "Boolean Controlled", DPTXlatorBoolean.DPT_BOOL);
  // DPT_ENABLE_CONTROL = new DPT1BitControlled("2.003", "Enable Controlled", DPTXlatorBoolean.DPT_ENABLE);
  // DPT_RAMP_CONTROL = new DPT1BitControlled("2.004", "Ramp Controlled", DPTXlatorBoolean.DPT_RAMP);
  // DPT_ALARM_CONTROL = new DPT1BitControlled("2.005", "Alarm Controlled", DPTXlatorBoolean.DPT_ALARM);
  // DPT_BINARY_CONTROL = new DPT1BitControlled("2.006", "Binary Controlled", DPTXlatorBoolean.DPT_BINARYVALUE);
  // DPT_STEP_CONTROL = new DPT1BitControlled("2.007", "Step Controlled", DPTXlatorBoolean.DPT_STEP);
  // DPT_UPDOWN_CONTROL = new DPT1BitControlled("2.008", "Up/Down Controlled", DPTXlatorBoolean.DPT_UPDOWN);
  // DPT_OPENCLOSE_CONTROL = new DPT1BitControlled("2.009", "Open/Close Controlled", DPTXlatorBoolean.DPT_OPENCLOSE);
  // DPT_START_CONTROL = new DPT1BitControlled("2.010", "Start Controlled", DPTXlatorBoolean.DPT_START);
  // DPT_STATE_CONTROL = new DPT1BitControlled("2.011", "State Controlled", DPTXlatorBoolean.DPT_STATE);
  // DPT_INVERT_CONTROL = new DPT1BitControlled("2.012", "Invert Controlled", DPTXlatorBoolean.DPT_INVERT);

  // Input: String
  // Example: "1 on", "1 off"
  ///////////////////////////////////////
  static toDPT2_1BitControlled(value: string) {
    // Check if the value length is valid
    if (value.length < 3) {
      throw new Error(`Wrong value format: ${value}`);
    }
    const booleanValue = value.substring(2).toLowerCase() === "on";

    let c = 0x0; // Initialize control bit `c` to 0
    if (value.startsWith("1 ")) {
      c = 0x2;
    } else if (!value.startsWith("0 ")) {
      throw new Error(`Invalid control bit: ${value}`);
    }
    const result = c + (booleanValue ? 1 : 0);
    return new Uint8Array([result]);
    // return result.toString(16).padStart(2, "0").toUpperCase();
  }

  static fromDPT2_1BitControlled(bytes: Uint8Array): string {
    if (bytes.length !== 1) {
      throw new Error("Invalid byte length for DPT2: expected 1 byte");
    }

    const value = bytes[0];

    const controlBit = (value & 0b10) >> 1; // Extract bit 1
    const dataBit = value & 0b01; // Extract bit 0

    const controlStr = controlBit === 1 ? "1" : "0";
    const dataStr = dataBit === 1 ? "on" : "off";

    return `${controlStr} ${dataStr}`;
  }

  ///////////////////////////////////////
  // DPT-3: 3 Bit Controlled

  // DPT_CONTROL_DIMMING = new DPT3BitControlled("3.007", "Dimming", DPTXlatorBoolean.DPT_STEP);
  // DPT_CONTROL_BLINDS = new DPT3BitControlled("3.008", "Blinds", DPTXlatorBoolean.DPT_UPDOWN);

  // Input: String
  // Example: "up 5", "down 2", "break"
  ///////////////////////////////////////
  static toDPT3_3BitControlled(value, dptCtrl) {
    // Tokenize the input value
    const tokens = value.split(/\s+/);
    if (tokens.length === 0) {
      throw new Error(`Translation error: wrong value format - ${value}`);
    }

    // Check for "break" keyword
    let firstToken = tokens[0];
    if (firstToken.toLowerCase() === "break") {
      return new Uint8Array([0]);
    }

    if (tokens.length < 2) {
      throw new Error(`Translation error: wrong value format - ${value}`);
    }

    // Initialize control bit
    let ctrl = 0;

    // Determine control bit based on DPT control's upper and lower values
    if (firstToken.toLowerCase() === dptCtrl.getUpperValue().toLowerCase()) {
      ctrl = 0x08;
    } else if (firstToken.toLowerCase() !== dptCtrl.getLowerValue().toLowerCase()) {
      throw new Error(`Translation error: unknown control value string - ${firstToken}`);
    }

    // Get the stepcode and handle any additional "break" case
    let secondToken = tokens[1];
    if (secondToken.toLowerCase() === "break") {
      secondToken = "0";
    }

    // Attempt to decode the stepcode
    const code = parseInt(secondToken, 10);
    if (isNaN(code) || code < 0 || code >= 8) {
      throw new Error(`Invalid stepcode - ${secondToken}`);
    }

    // Combine control bit and stepcode, and return as Uint8Array
    return new Uint8Array([ctrl + code]);
  }

  static fromDPT3_3BitControlled(
    bytes: Uint8Array,
    dptCtrl: { getUpperValue: () => string; getLowerValue: () => string },
  ): string {
    if (bytes.length !== 1) {
      throw new Error("Invalid DPT3 buffer length: expected 1 byte");
    }

    const byte = bytes[0];

    // Special case: "break"
    if (byte === 0) {
      return "break";
    }

    const controlBit = (byte & 0b1000) >> 3;
    const stepCode = byte & 0b0111;

    const controlStr = controlBit === 1 ? dptCtrl.getUpperValue() : dptCtrl.getLowerValue();
    const stepStr = stepCode === 0 ? "break" : stepCode.toString();

    return `${controlStr} ${stepStr}`;
  }

  ///////////////////////////////////////
  // DPT-4: Character (ASCII, 8859_1)

  ///////////////////////////////////////
  // DPT-5: 8 Bit Unsigned

  // DPT_SCALING = new DPT("5.001", "Scaling", "0", "100", "%");
  // DPT_ANGLE = new DPT("5.003", "Angle", "0", "360", "°");
  // DPT_PERCENT_U8 = new DPT("5.004", "Percent (8 Bit)", "0", "255", "%");
  // DPT_DECIMALFACTOR = new DPT("5.005", "Decimal factor", "0", "255", "ratio");
  // DPT_TARIFF = new DPT("5.006", "Tariff information", "0", "254"); // 255: reserved, shall not be transmitted
  // DPT_VALUE_1_UCOUNT = new DPT("5.010", "Unsigned count", "0", "255", "counter pulses");
  // DptFanStage = new DPT("5.100", "fan stage", "0", "255", "fan stage");
  static toDPT5_8BitUnsigned(value, dpt) {
    const DPT_UPPER_VALUE = dpt === "5.001" ? 100 : dpt === "5.003" ? 360 : dpt === "5.006" ? 254 : 255;
    const DPT_LOWER_VALUE = 0;

    if (value < DPT_LOWER_VALUE || value > DPT_UPPER_VALUE) {
      throw new Error(`Translation error, input value out of range [${DPT_LOWER_VALUE}..${DPT_UPPER_VALUE}]: ${value}`);
    }
    if (dpt === "5.001") {
      return Math.round((value * 255) / 100) & 0xff;
    } else if (dpt === "5.003") {
      return Math.round((value * 255) / 360) & 0xff;
    } else {
      return Math.round(value) & 0xff;
    }
  }

  static fromDPT5_8BitUnsigned(byte: number | Uint8Array, dpt: string): number {
    const rawValue = byte instanceof Uint8Array ? byte[0] : byte;

    if (rawValue < 0 || rawValue > 255) {
      throw new Error(`Invalid byte value: ${rawValue}. Expected range 0–255.`);
    }

    if (dpt === "5.001") {
      // Percent (0–100%)
      return parseFloat(((rawValue * 100) / 255).toFixed(2));
    } else if (dpt === "5.003") {
      // Angle (0–360°)
      return parseFloat(((rawValue * 360) / 255).toFixed(2));
    } else if (dpt === "5.006") {
      // Count (0–254)
      return Math.min(rawValue, 254);
    } else {
      // Default 8-bit unsigned (0–255)
      return rawValue;
    }
  }

  ///////////////////////////////////////
  // DPT-6: 8 Bit Signed

  // DPT_PERCENT_V8 = new DPT("6.001", "Percent (8 Bit)", "-128", "127", "%");
  // DPT_VALUE_1_UCOUNT = new DPT("6.010", "signed count", "-128", "127", "counter pulses");
  // DPT_STATUS_MODE3 = new DPT("6.020", "status with mode", "0/0/0/0/0 0", "1/1/1/1/1 2");
  static toDPT6_8BitSigned(value) {
    const result = new Uint8Array(1);

    // For DPT = 6.020 (DPT_STATUS_MODE3)
    if (value.length === 11) {
      let d = 0;

      // First 10 characters: status bits
      for (let i = 0; i < 5; i++) {
        const c = value.charAt(2 * i);
        if (c === "1") {
          d |= 1 << (7 - i);
        } else if (c !== "0") {
          throw new Error(`Invalid status at position ${2 * i}: ${c}`);
        }
      }

      // 11th character: mode information
      const c = value.charAt(10);
      if (c === "0") {
        d += 1;
      } else if (c === "1") {
        d += 2;
      } else if (c === "2") {
        d += 4;
      } else {
        throw new Error(`Invalid mode character: ${c}`);
      }

      result[0] = d;
      return result;
    }

    // For 6.001 & 6.010, try to decode it as a signed 8-bit integer
    try {
      const parsedValue = parseInt(value, 10);
      if (parsedValue < -128 || parsedValue > 127) {
        throw new Error(`Value out of range for 8-bit signed integer: ${parsedValue}`);
      }

      result[0] = parsedValue & 0xff;
      return result;
    } catch (e) {
      throw new Error(`Wrong value format: ${value}`);
    }
  }

  static fromDPT6_8BitSigned(byte: number | Uint8Array): string {
    const raw = byte instanceof Uint8Array ? byte[0] : byte;

    if (typeof raw !== "number" || raw < 0 || raw > 255) {
      throw new Error(`Invalid byte value: ${raw}`);
    }

    // Special case: DPT 6.020 format (11-char string with 5 status bits + 1 mode)
    const statusBits: string[] = [];
    for (let i = 7; i >= 3; i--) {
      const bit = (raw >> i) & 0x01;
      statusBits.push(bit.toString());
      statusBits.push(" "); // spacing like original formatting
    }

    // Total of 5 bits with spacing = 10 characters
    const statusPart = statusBits.join("").trimEnd();

    const modeBits = raw & 0x07;
    let modeChar = "";
    switch (modeBits) {
      case 1:
        modeChar = "0";
        break;
      case 2:
        modeChar = "1";
        break;
      case 4:
        modeChar = "2";
        break;
      default:
        modeChar = ""; // Not a valid mode encoding
    }

    if (modeChar !== "") {
      return `${statusPart}${modeChar}`; // e.g., "1 0 0 1 0 2"
    }

    // Default fallback: interpret as signed 8-bit integer
    const signedValue = raw > 127 ? raw - 256 : raw;
    return signedValue.toString();
  }

  ///////////////////////////////////////
  // DPT-7: 2 Byte Unsigned

  // DPT_VALUE_2_UCOUNT = new DPT("7.001", "Unsigned count", "0", "65535", "pulses");
  // DPT_TIMEPERIOD = new DPT("7.002", "Time period in ms", "0", "65535", "ms");
  // DPT_TIMEPERIOD_10 = new DPT("7.003", "Time period (resolution 10 ms)", "0", "655350", "ms");
  // DPT_TIMEPERIOD_100 = new DPT("7.004", "Time period (resolution 100 ms)", "0", "6553500", "ms");
  // DPT_TIMEPERIOD_SEC = new DPT("7.005", "Time period in seconds", "0", "65535", "s");
  // DPT_TIMEPERIOD_MIN = new DPT("7.006", "Time period in minutes", "0", "65535", "min");
  // DPT_TIMEPERIOD_HOURS = new DPT("7.007", "Time period in hours", "0", "65535", "h");
  // DPT_PROP_DATATYPE = new DPT("7.010", "Interface object type", "0", "65535", "");
  // DPT_LENGTH = new DPT("7.011", "Length in mm", "0", "65535", "mm");
  // DPT_ELECTRICAL_CURRENT = new DPT("7.012", "Electrical current", "0", "65535", "mA");
  // DPT_BRIGHTNESS = new DPT("7.013", "Brightness", "0", "65535", "lx");
  // DPT_ABSOLUTE_COLOR_TEMPERATURE = new DPT("7.600", "Absolute color temperature", "0", "65535", "K");

  // Input: number
  // Example Input: "-2" "273.16"
  ///////////////////////////////////////
  static toDPT7_2ByteUnsigned(value: number, dpt) {
    if (value < 0 || value > 6553500) {
      throw new Error(`Translation error: input value out of range [0..65535]`);
    }
    // Scale the value based on DPT type
    let v;
    if (dpt === "DPT_TIMEPERIOD_10") {
      // 7.003
      v = Math.round(value / 10);
    } else if (dpt === "DPT_TIMEPERIOD_100") {
      // 7.004
      v = Math.round(value / 100);
    } else {
      v = Math.round(value);
    }

    const highByte = (v >> 8) & 0xff;
    const lowByte = v & 0xff;
    return new Uint8Array([highByte, lowByte]);
  }

  static fromDPT7_2ByteUnsigned(bytes: Uint8Array, dpt: string): number {
    if (!(bytes instanceof Uint8Array) || bytes.length !== 2) {
      throw new Error(`Input must be a Uint8Array of length 2`);
    }

    const rawValue = (bytes[0] << 8) | bytes[1];

    // Scale the value based on the DPT type
    switch (dpt) {
      case "DPT_TIMEPERIOD_10": // 7.003
        return rawValue * 10;
      case "DPT_TIMEPERIOD_100": // 7.004
        return rawValue * 100;
      default: // default for "DPT_VALUE_2_UCOUNT", "DPT_TIMEPERIOD_1", etc.
        return rawValue;
    }
  }

  ///////////////////////////////////////
  // DPT-8: 2 Byte Signed

  // DptValueCount = new DPT("8.001", "signed count", "-32768", "32767", "pulses");
  // DptDeltaTime = new DPT("8.002", "delta time in ms", "-32768", "32767", "ms");
  // DptDeltaTime10 = new DPT("8.003", "delta time in ms (resolution 10 ms)", "-327680", "327670", "ms");
  // DptDeltaTime100 = new DPT("8.004", "delta time in ms (resolution 100 ms)", "-3276800", "3276700", "ms");
  // DptDeltaTimeSec = new DPT("8.005", "delta time in seconds", "-32768", "32767", "s");
  // DptDeltaTimeMin = new DPT("8.006", "delta time in minutes", "-32768", "32767", "min");
  // DptDeltaTimeHours = new DPT("8.007", "delta time in hours", "-32768", "32767", "h");
  // DptPercent = new DPT("8.010", "percent", "-327.68", "327.67", "%");
  // DptRotationAngle = new DPT("8.011", "rotation angle", "-32768", "32767", "°");
  // DptLength = new DPT("8.012", "length in m", "-32768", "32767", "m");

  // Example: toDPT8_2ByteSigned(123.45,"DptDeltaTime10",0)
  static toDPT8_2ByteSigned(value, dpt, index) {
    let min, max;
    if (dpt === "DptDeltaTime10") {
      min = -327680;
      max = 327670;
    } else if (dpt === "DptDeltaTime100") {
      min = -3276800;
      max = 3276700;
    } else if (dpt === "DptPercent") {
      min = -327.68;
      max = 327.67;
    } else {
      min = -32768;
      max = 32767;
    }

    if (value < min || value > max) {
      throw new Error(`Translation error, input value out of range [${min}..${max}]`);
    }

    let v;

    if (dpt === "DptDeltaTime10") {
      v = Math.round(value / 10);
    } else if (dpt === "DptDeltaTime100") {
      v = Math.round(value / 100);
    } else if (dpt === "DptPercent") {
      v = Math.round(value * 100);
    } else {
      v = Math.round(value);
    }

    const dst = new Uint8Array(2 * index + 2); // 2 bytes per entry
    dst[2 * index] = (v >> 8) & 0xff; // High Byte
    dst[2 * index + 1] = v & 0xff; // Low Byte

    return dst;
  }

  static fromDPT8_2ByteSigned(bytes: Uint8Array, dpt: string, index: number = 0): number {
    if (!(bytes instanceof Uint8Array) || bytes.length < 2 * (index + 1)) {
      throw new Error(`Input must be a Uint8Array with at least ${2 * (index + 1)} bytes`);
    }

    const highByte = bytes[2 * index];
    const lowByte = bytes[2 * index + 1];
    const raw = (highByte << 8) | lowByte;

    // Interpret as signed 16-bit integer
    const signedValue = raw & 0x8000 ? raw - 0x10000 : raw;

    // Scale based on DPT
    switch (dpt) {
      case "DptDeltaTime10":
        return signedValue * 10;
      case "DptDeltaTime100":
        return signedValue * 100;
      case "DptPercent":
        return signedValue / 100;
      default:
        return signedValue;
    }
  }

  ///////////////////////////////////////
  // DPT-9: 2 Byte Float
  // Verified on test device memory map

  // DPT_TEMPERATURE = new DPT("9.001", "Temperature", "-273", "670433.28", "°C");
  // DPT_TEMPERATURE_DIFFERENCE = new DPT("9.002", "Temperature difference", "-671088.64","670433.28", "K");
  // DPT_TEMPERATURE_GRADIENT = new DPT("9.003", "Temperature gradient", "-671088.64","670433.28", "K/h");
  // DPT_INTENSITY_OF_LIGHT = new DPT("9.004", "Light intensity", "0", "670433.28", "lx");
  // DPT_WIND_SPEED = new DPT("9.005", "Wind speed", "0", "670433.28", "m/s");
  // DPT_AIR_PRESSURE = new DPT("9.006", "Air pressure", "0", "670433.28", "Pa");
  // DPT_HUMIDITY = new DPT("9.007", "Humidity", "0", "670433.28", "%");
  // DPT_AIRQUALITY = new DPT("9.008", "Air quality", "0", "670433.28", "ppm");
  // DPT_AIR_FLOW = new DPT("9.009", "Air flow", "-671088.64", "670433.28", "m³/h");
  // DPT_TIME_DIFFERENCE1 = new DPT("9.010", "Time difference 1", "-671088.64", "670433.28", "s");
  // DPT_TIME_DIFFERENCE2 = new DPT("9.011", "Time difference 2", "-671088.64", "670433.28", "ms");
  // DPT_VOLTAGE = new DPT("9.020", "Voltage", "-671088.64", "670433.28", "mV");
  // DPT_ELECTRICAL_CURRENT = new DPT("9.021", "Electrical current", "-671088.64", "670433.28", "mA");
  // DPT_POWERDENSITY = new DPT("9.022", "Power density", "-671088.64", "670433.28", "W/m²");
  // DPT_KELVIN_PER_PERCENT = new DPT("9.023", "Kelvin/percent", "-671088.64", "670433.28", "K/%");
  // DPT_POWER = new DPT("9.024", "Power", "-671088.64", "670433.28", "kW");
  // DPT_VOLUME_FLOW = new DPT("9.025", "Volume flow", "-671088.64", "670433.28", "l/h");
  // DPT_RAIN_AMOUNT = new DPT("9.026", "Rain amount", "-671088.64", "670433.28", "l/m²");
  // DPT_TEMP_F = new DPT("9.027", "Temperature", "-459.6", "670433.28", "°F");
  // DPT_WIND_SPEED_KMH = new DPT("9.028", "Wind speed", "0", "670433.28", "km/h");
  // DptAbsoluteHumidity = new DPT("9.029", "absolute humidity", "0", "670760", "g/m³");
  // DptConcentration = new DPT("9.030", "concentration", "0", "670760", "µg/m³");

  // Input: number
  // Example Input: "-2" "273.16"
  ///////////////////////////////////////
  static toDPT9_2ByteFloat(value: number) {
    const min = -671089; // negLimit = -671088.64d;
    const max = 670761; // posLimit = 670760.96d;

    if (value < min || value > max) {
      throw new Error(`Translation error: value out of range [${min}..${max}]`);
    }
    let v = value * 100; // Scale the value by 100 for precision
    let exponent = 0;
    while (v < -2048) {
      // Adjust exponent to fit mantissa in 11 bits (-2048 to 2047)
      v /= 2;
      exponent++;
    }
    while (v > 2047) {
      v /= 2;
      exponent++;
    }

    const mantissa = Math.round(v) & 0x7ff; // Round mantissa into 11 bits and ensure it's within range

    let msb = (exponent << 3) | (mantissa >> 8); // MSB = using exponent and sign bit
    if (value < 0) msb |= 0x80; // sign bit

    const lsb = mantissa & 0xff; // LSB = lower 8 bits of the mantissa
    return new Uint8Array([msb, lsb]); // 2 Bytes[MSB,LSB]
  }

  static fromDPT9_2ByteFloat(bytes: [number, number] | Uint8Array): number {
    if (bytes.length !== 2) {
      throw new Error("Invalid input length. Expected 2 bytes.");
    }

    const msb = bytes[0];
    const lsb = bytes[1];

    const sign = msb & 0x80 ? -1 : 1; // Bit 7 = sign
    const exponent = (msb & 0x78) >> 3; // Bits 6..3 = exponent (4 bits)
    const mantissa = ((msb & 0x07) << 8) | lsb; // Bits 2..0 + 8 LSBs

    // Sign-extend 11-bit mantissa to signed int
    const signedMantissa = mantissa >= 0x400 ? mantissa - 0x800 : mantissa;

    const value = sign * 0.01 * signedMantissa * Math.pow(2, exponent);
    return parseFloat(value.toFixed(6)); // optional rounding for readability
  }

  ///////////////////////////////////////
  // DPT-10 : Time
  // DPT_TIMEOFDAY = new DPT("10.001", "Time of day", "no-day, 00:00:00", "Sun, 23:59:59", "dow, hh:mm:ss");

  static toDPT10_Time(milliseconds) {
    const date = new Date(milliseconds);
    const dow = (date.getDay() + 1) % 7; // getDay() returns 0 (Sunday) to 6 (Saturday), adjust to 1 (Monday) to 7 (Sunday)
    const hour = date.getHours();
    const minute = date.getMinutes();
    const second = date.getSeconds();

    if (dow < 1 || dow > 7) throw new Error("Day of week out of range [1..7]");
    if (hour < 0 || hour > 23) throw new Error("Hour out of range [0..23]");
    if (minute < 0 || minute > 59) throw new Error("Minute out of range [0..59]");
    if (second < 0 || second > 59) throw new Error("Second out of range [0..59]");

    const result = new Uint8Array(3);
    result[0] = (dow << 5) | hour;
    result[1] = minute;
    result[2] = second; // Get last two digits of the year
    return result;
  }

  static fromDPT10_Time(bytes: Uint8Array): number {
    if (!(bytes instanceof Uint8Array) || bytes.length !== 3) {
      throw new Error("Input must be a Uint8Array of length 3");
    }

    const dow = (bytes[0] >> 5) & 0x07;
    const hour = bytes[0] & 0x1f;
    const minute = bytes[1];
    const second = bytes[2];

    if (dow < 1 || dow > 7) throw new Error("Day of week out of range [1..7]");
    if (hour > 23) throw new Error("Hour out of range [0..23]");
    if (minute > 59) throw new Error("Minute out of range [0..59]");
    if (second > 59) throw new Error("Second out of range [0..59]");

    // Create a date with today’s date, set time to decoded hour:min:sec
    const now = new Date();
    const today = new Date(now.getFullYear(), now.getMonth(), now.getDate(), hour, minute, second);

    // Adjust to match the decoded DOW (1 = Monday ... 7 = Sunday)
    const todayDOW = ((today.getDay() + 6) % 7) + 1; // Convert JS DOW to KNX DOW
    const dayOffset = dow - todayDOW;
    today.setDate(today.getDate() + dayOffset);

    return today.getTime(); // milliseconds since epoch
  }

  ///////////////////////////////////////
  // DPT-11 : Date
  // DPT_DATE = new DPT("11.001", "Date", "1990-01-01", "2089-12-31", "yyyy-mm-dd");

  static toDPT11_Date(milliseconds) {
    const date = new Date(milliseconds);
    const year = date.getFullYear();
    const month = date.getMonth() + 1; // JavaScript months are 0-based, so add 1
    const day = date.getDate();

    if (year < 1990 || year > 2089) {
      throw new Error("Year out of range [1990..2089]");
    }
    if (month < 1 || month > 12) {
      throw new Error("Month out of range [1..12]");
    }
    if (day < 1 || day > 31) {
      throw new Error("Day out of range [1..31]");
    }

    const result = new Uint8Array(3);
    result[0] = day;
    result[1] = month;
    result[2] = year % 100; // Get last two digits of the year
    return result;
  }

  static fromDPT11_Date(bytes: Uint8Array): number {
    if (!(bytes instanceof Uint8Array) || bytes.length !== 3) {
      throw new Error("Input must be a Uint8Array of length 3");
    }

    const day = bytes[0];
    const month = bytes[1];
    const yearLastTwoDigits = bytes[2];

    if (day < 1 || day > 31) throw new Error("Day out of range [1..31]");
    if (month < 1 || month > 12) throw new Error("Month out of range [1..12]");
    if (yearLastTwoDigits > 99) throw new Error("Invalid year format");

    // KNX DPT11 covers years 1990–2089
    const year = yearLastTwoDigits + (yearLastTwoDigits >= 90 ? 1900 : 2000);

    const date = new Date(year, month - 1, day); // Month is 0-based in JS
    return date.getTime(); // Milliseconds since epoch
  }

  ///////////////////////////////////////
  // DPT-12: 4 Byte Unsigned
  // Default return value after creation is 0.

  // DPT_VALUE_4_UCOUNT = new DPT("12.001", "Unsigned count", "0", "4294967295", "counter pulses");
  // DptTimePeriodSec = new DPT("12.100", "counter time [s]", "0", "4294967295", "s");
  // DptTimePeriodMin = new DPT("12.101", "counter time [min]", "0", "4294967295", "min");
  // DptTimePeriodHours = new DPT("12.102", "counter time [h]", "0", "4294967295", "h");
  // DptVolumeLiquid = new DPT("12.1200", "volume liquid [liter]", "0", "4294967295", "l");
  // DptVolume = new DPT("12.1201", "volume [m³]", "0", "4294967295", "m³");

  // Input: number
  ///////////////////////////////////////
  static toDPT12_4ByteUnsigned(value) {
    if (value < 0 || value > 0xffffffff) {
      throw new Error("Translation error, input value out of range: " + value);
    }
    const result = new Uint8Array(4);
    result[0] = (value >> 24) & 0xff;
    result[1] = (value >> 16) & 0xff;
    result[2] = (value >> 8) & 0xff;
    result[3] = value & 0xff;

    return result;
  }

  static fromDPT12_4ByteUnsigned(bytes: Uint8Array): number {
    if (!(bytes instanceof Uint8Array) || bytes.length !== 4) {
      throw new Error("Input must be a Uint8Array of length 4");
    }

    const value =
      ((bytes[0] << 24) >>> 0) | // >>> 0 ensures unsigned shift for high byte
      (bytes[1] << 16) |
      (bytes[2] << 8) |
      bytes[3];

    return value;
  }

  ///////////////////////////////////////
  // DPT-13: 4 Byte Signed
  // Default return value after creation is 0.

  // DPT_COUNT = new DPT("13.001", "Counter pulses", "-2147483648", "2147483647", "counter pulses");
  // DPT_FLOWRATE = new DPT("13.002", "Flow rate", "-2147483648", "2147483647", "m3/h");
  // DPT_ACTIVE_ENERGY = new DPT("13.010", "Active Energy", "-2147483648", "2147483647", "Wh");
  // DPT_APPARENT_ENERGY = new DPT("13.011", "Apparent energy", "-2147483648", "2147483647", "VAh");
  // DPT_REACTIVE_ENERGY = new DPT("13.012", "Reactive energy","-2147483648", "2147483647", "VARh");
  // DPT_ACTIVE_ENERGY_KWH = new DPT("13.013", "Active energy in kWh","-2147483648", "2147483647", "kWh");
  // DPT_APPARENT_ENERGY_KVAH = new DPT("13.014", "Apparent energy in kVAh","-2147483648", "2147483647", "kVAh");
  // DPT_REACTIVE_ENERGY_KVARH = new DPT("13.015", "Reactive energy in kVARh", "-2147483648", "2147483647", "kVARh");
  // DptActiveEnergyMWh = new DPT("13.016","Active energy in MWh", "-2147483648", "2147483647", "MWh");
  // DPT_DELTA_TIME = new DPT("13.100", "time lag", "-2147483648", "2147483647", "s");
  // DPT_DELTA_VOLUME_LIQUID_LITER = new DPT("13.1200", "volume liquid [l]", "-2147483648", "2147483647", "l");
  // DPT_DELTA_VOLUME_M3 = new DPT("13.1201", "volume [m³]", "-2147483648", "2147483647", "m³");

  // Input: number
  ///////////////////////////////////////
  static toDPT13_4ByteSigned(value) {
    const result = new Uint8Array(4);
    result[0] = (value >> 24) & 0xff;
    result[1] = (value >> 16) & 0xff;
    result[2] = (value >> 8) & 0xff;
    result[3] = value & 0xff;
    return result;
  }

  static fromDPT13_4ByteSigned(bytes: Uint8Array): number {
    if (!(bytes instanceof Uint8Array) || bytes.length !== 4) {
      throw new Error("Input must be a Uint8Array of length 4");
    }

    // Combine bytes into a signed 32-bit integer
    const value = (bytes[0] << 24) | (bytes[1] << 16) | (bytes[2] << 8) | bytes[3];

    return value; // JavaScript bitwise operators automatically return a signed 32-bit integer
  }

  ///////////////////////////////////////
  // DPT-14 : 4 Byte Float
  // KNX 4 Octet Float is encoded in the IEEE 754 floating point format.
  // It allocates 4 Bytes as follows, MSB to LSB:
  // | 1 bit Sign | 8 bit exponent | 23 bit mantissa |

  // DPT_ACCELERATION = new DPT("14.000", "Acceleration", "-3.40282347e+38f", "3.40282347e+38f", "ms⁻²");
  // DPT_ACCELERATION_ANGULAR = new DPT("14.001", "Acceleration, angular", "-3.40282347e+38f", "3.40282347e+38f", "rad s⁻²");
  // DPT_ACTIVATION_ENERGY = new DPT("14.002", "Activation energy", "-3.40282347e+38f", "3.40282347e+38f", "J/mol");
  // DPT_ACTIVITY = new DPT("14.003", "Activity", "-3.40282347e+38f", "3.40282347e+38f", "s⁻¹");
  // DPT_MOL = new DPT("14.004", "Mol", "-3.40282347e+38f", "3.40282347e+38f", "mol");
  // DPT_AMPLITUDE = new DPT("14.005", "Amplitude", "-3.40282347e+38f", "3.40282347e+38f");
  // DPT_ANGLE_RAD = new DPT("14.006", "Angle", "-3.40282347e+38f", "3.40282347e+38f", "rad");
  // DPT_ANGLE_DEG = new DPT("14.007", "Angle", "-3.40282347e+38f", "3.40282347e+38f", "°");
  // DPT_ANGULAR_MOMENTUM = new DPT("14.008", "Momentum", "-3.40282347e+38f", "3.40282347e+38f", "Js");
  // DPT_ANGULAR_VELOCITY = new DPT("14.009", "Angular velocity", "-3.40282347e+38f", "3.40282347e+38f", "rad/s");
  // DPT_AREA = new DPT("14.010", "Area", "-3.40282347e+38f", "3.40282347e+38f", "m²");
  // DPT_CAPACITANCE = new DPT("14.011", "Capacitance", "-3.40282347e+38f", "3.40282347e+38f", "F");
  // DPT_CHARGE_DENSITY_SURFACE = new DPT("14.012", "Charge density (surface)", "-3.40282347e+38f", "3.40282347e+38f", "C m⁻²");
  // DPT_CHARGE_DENSITY_VOLUME = new DPT("14.013", "Charge density (volume)", "-3.40282347e+38f", "3.40282347e+38f", "C m⁻³");
  // DPT_COMPRESSIBILITY = new DPT("14.014", "Compressibility", "-3.40282347e+38f", "3.40282347e+38f", "m²/N");
  // DPT_CONDUCTANCE = new DPT("14.015", "Conductance", "-3.40282347e+38f", "3.40282347e+38f", "Ω⁻¹");
  // DPT_ELECTRICAL_CONDUCTIVITY = new DPT("14.016", "Conductivity, electrical", "-3.40282347e+38f", "3.40282347e+38f", "Ω⁻¹m⁻¹");
  // DPT_DENSITY = new DPT("14.017", "Density", "-3.40282347e+38f", "3.40282347e+38f", "kg m⁻³");
  // DPT_ELECTRIC_CHARGE = new DPT("14.018", "Electric charge", "-3.40282347e+38f", "3.40282347e+38f", "C");
  // DPT_ELECTRIC_CURRENT = new DPT("14.019", "Electric current", "-3.40282347e+38f", "3.40282347e+38f", "A");
  // DPT_ELECTRIC_CURRENTDENSITY = new DPT("14.020", "Electric current density", "-3.40282347e+38f", "3.40282347e+38f", "A m⁻²");
  // DPT_ELECTRIC_DIPOLEMOMENT = new DPT("14.021", "Electric dipole moment", "-3.40282347e+38f", "3.40282347e+38f", "Cm");
  // DPT_ELECTRIC_DISPLACEMENT = new DPT("14.022", "Electric displacement", "-3.40282347e+38f", "3.40282347e+38f", "C m⁻²");
  // DPT_ELECTRIC_FIELDSTRENGTH = new DPT("14.023", "Electric field strength", "-3.40282347e+38f", "3.40282347e+38f", "V/m");
  // DPT_ELECTRIC_FLUX = new DPT("14.024", "Electric flux", "-3.40282347e+38f", "3.40282347e+38f", "Vm");
  // DPT_ELECTRIC_FLUX_DENSITY = new DPT("14.025", "Electric flux density", "-3.40282347e+38f", "3.40282347e+38f", "C m⁻²");
  // DPT_ELECTRIC_POLARIZATION = new DPT("14.026", "Electric polarization", "-3.40282347e+38f", "3.40282347e+38f", "C m⁻²");
  // DPT_ELECTRIC_POTENTIAL = new DPT("14.027", "Electric potential", "-3.40282347e+38f", "3.40282347e+38f", "V");
  // DPT_ELECTRIC_POTENTIAL_DIFFERENCE = new DPT("14.028", "Electric potential difference", "-3.40282347e+38f", "3.40282347e+38f", "V");
  // DPT_ELECTROMAGNETIC_MOMENT = new DPT("14.029", "Electromagnetic moment", "-3.40282347e+38f", "3.40282347e+38f", "A m²");
  // DPT_ELECTROMOTIVE_FORCE = new DPT("14.030", "Electromotive force", "-3.40282347e+38f", "3.40282347e+38f", "V");
  // DPT_ENERGY = new DPT("14.031", "Energy", "-3.40282347e+38f", "3.40282347e+38f", "J");
  // DPT_FORCE = new DPT("14.032", "Force", "-3.40282347e+38f", "3.40282347e+38f", "N");
  // DPT_FREQUENCY = new DPT("14.033", "Frequency", "-3.40282347e+38f", "3.40282347e+38f", "Hz");
  // DPT_ANGULAR_FREQUENCY = new DPT("14.034", "Frequency, angular", "-3.40282347e+38f", "3.40282347e+38f", "rad/s");
  // DPT_HEAT_CAPACITY = new DPT("14.035", "Heat capacity", "-3.40282347e+38f", "3.40282347e+38f", "J/K");
  // DPT_HEAT_FLOWRATE = new DPT("14.036", "Heat flow rate", "-3.40282347e+38f", "3.40282347e+38f", "W");
  // DPT_HEAT_QUANTITY = new DPT("14.037", "Heat quantity", "-3.40282347e+38f", "3.40282347e+38f", "J");
  // DPT_IMPEDANCE = new DPT("14.038", "Impedance", "-3.40282347e+38f", "3.40282347e+38f", "Ω");
  // DPT_LENGTH = new DPT("14.039", "Length", "-3.40282347e+38f", "3.40282347e+38f", "m");
  // DPT_LIGHT_QUANTITY = new DPT("14.040", "Light quantity", "-3.40282347e+38f", "3.40282347e+38f", "J");
  // DPT_LUMINANCE = new DPT("14.041", "Luminance", "-3.40282347e+38f", "3.40282347e+38f", "cd m⁻²");
  // DPT_LUMINOUS_FLUX = new DPT("14.042", "Luminous flux", "-3.40282347e+38f", "3.40282347e+38f", "lm");
  // DPT_LUMINOUS_INTENSITY = new DPT("14.043", "Luminous intensity", "-3.40282347e+38f", "3.40282347e+38f", "cd");
  // DPT_MAGNETIC_FIELDSTRENGTH = new DPT("14.044", "Magnetic field strength", "-3.40282347e+38f", "3.40282347e+38f", "A/m");
  // DPT_MAGNETIC_FLUX = new DPT("14.045", "Magnetic flux", "-3.40282347e+38f", "3.40282347e+38f", "Wb");
  // DPT_MAGNETIC_FLUX_DENSITY = new DPT("14.046", "Magnetic flux density", "-3.40282347e+38f", "3.40282347e+38f", "T");
  // DPT_MAGNETIC_MOMENT = new DPT("14.047", "Magnetic moment", "-3.40282347e+38f", "3.40282347e+38f", "A m²");
  // DPT_MAGNETIC_POLARIZATION = new DPT("14.048", "Magnetic polarization","-3.40282347e+38f", "3.40282347e+38f", "T");
  // DPT_MAGNETIZATION = new DPT("14.048", "Magnetization", "-3.40282347e+38f", "3.40282347e+38f", "A m⁻¹");
  // DPT_MAGNETIC_VECTORPOTENTIAL = new DPT("14.049", "Magnetic vector potential", "-3.40282347e+38f", "3.40282347e+38f", "V s/m");
  // DPT_MAGNETOMOTIVE_FORCE = new DPT("14.050", "Magneto motive force", "-3.40282347e+38f", "3.40282347e+38f", "A");
  // DPT_MASS = new DPT("14.051", "Mass", "-3.40282347e+38f", "3.40282347e+38f", "kg");
  // DPT_MASS_FLUX = new DPT("14.052", "Mass flux", "-3.40282347e+38f", "3.40282347e+38f", "kg/s");
  // DPT_MOMENTUM = new DPT("14.053", "Momentum", "-3.40282347e+38f", "3.40282347e+38f", "N s");
  // DPT_PHASE_ANGLE_RAD = new DPT("14.054", "Phase angle", "-3.40282347e+38f", "3.40282347e+38f", "rad");
  // DPT_PHASE_ANGLE_DEG = new DPT("14.055", "Phase angle", "-3.40282347e+38f", "3.40282347e+38f", "°");
  // DPT_POWER = new DPT("14.056", "Power", "-3.40282347e+38f", "3.40282347e+38f", "W");
  // DPT_POWER_FACTOR = new DPT("14.057", "Power factor", "-3.40282347e+38f", "3.40282347e+38f");
  // DPT_PRESSURE = new DPT("14.058", "Pressure", "-3.40282347e+38f", "3.40282347e+38f", "Pa");
  // DPT_REACTANCE = new DPT("14.059", "Reactance", "-3.40282347e+38f", "3.40282347e+38f", "Ω");
  // DPT_RESISTANCE = new DPT("14.060", "Resistance", "-3.40282347e+38f", "3.40282347e+38f", "Ω");
  // DPT_RESISTIVITY = new DPT("14.061", "Resistivity", "-3.40282347e+38f", "3.40282347e+38f", "Ω m");
  // DPT_SELF_INDUCTANCE = new DPT("14.062", "Self inductance", "-3.40282347e+38f", "3.40282347e+38f", "H");
  // DPT_SOLID_ANGLE = new DPT("14.063", "Solid angle", "-3.40282347e+38f", "3.40282347e+38f", "sr");
  // DPT_SOUND_INTENSITY = new DPT("14.064", "Sound intensity", "-3.40282347e+38f", "3.40282347e+38f", "W/m²");
  // DPT_SPEED = new DPT("14.065", "Speed", "-3.40282347e+38f", "3.40282347e+38f", "m/s");
  // DPT_STRESS = new DPT("14.066", "Stress", "-3.40282347e+38f", "3.40282347e+38f", "Pa");
  // DPT_SURFACE_TENSION = new DPT("14.067", "Surface tension", "-3.40282347e+38f", "3.40282347e+38f", "N/m");
  // DPT_COMMON_TEMPERATURE = new DPT("14.068",  "Temperature in Celsius Degree", "-3.40282347e+38f", "3.40282347e+38f", "°C");
  // DPT_ABSOLUTE_TEMPERATURE = new DPT("14.069", "Temperature, absolute",  "-3.40282347e+38f", "3.40282347e+38f", "K");
  // DPT_TEMPERATURE_DIFFERENCE = new DPT("14.070", "Temperature difference", "-3.40282347e+38f", "3.40282347e+38f", "K");
  // DPT_THERMAL_CAPACITY = new DPT("14.071", "Thermal capacity", "-3.40282347e+38f", "3.40282347e+38f", "J/K");
  // DPT_THERMAL_CONDUCTIVITY = new DPT("14.072", "Thermal conductivity", "-3.40282347e+38f", "3.40282347e+38f", "W/m K⁻¹");
  // DPT_THERMOELECTRIC_POWER = new DPT("14.073", "Thermoelectric power", "-3.40282347e+38f", "3.40282347e+38f", "V/K");
  // DPT_TIME = new DPT("14.074", "Time", "-3.40282347e+38f", "3.40282347e+38f", "s");
  // DPT_TORQUE = new DPT("14.075", "Torque", "-3.40282347e+38f", "3.40282347e+38f", "Nm");
  // DPT_VOLUME = new DPT("14.076", "Volume", "-3.40282347e+38f", "3.40282347e+38f", "m³");
  // DPT_VOLUME_FLOW = new DPT("14.077", "Volume flow", "-3.40282347e+38f", "3.40282347e+38f", "m³/s");
  // DPT_WEIGHT = new DPT("14.078", "Weight", "-3.40282347e+38f", "3.40282347e+38f", "N");
  // DPT_WORK = new DPT("14.079", "Work", "-3.40282347e+38f", "3.40282347e+38f", "J");
  // DPT_APPARENT_POWER = new DPT("14.080", "Apparent Power", "-3.40282347e+38f", "3.40282347e+38f", "VA");
  // DPT_VOLUME_FLUX_METER = new DPT("14.1200", "volume flux [m³/h]", "-3.40282347e+38f", "3.40282347e+38f", "m³/h");
  // DPT_VOLUME_FLUX_LS = new DPT("14.1201", "volume flux [l/s]", "-3.40282347e+38f", "3.40282347e+38f", "l/s");

  // Input: number
  // Range: -3.40282347e+38f to 3.40282347e+38f
  ///////////////////////////////////////
  static toDPT14_4ByteFloat(value: number) {
    const min = -3.40282347e38;
    const max = 3.40282347e38;
    if (value < min || value > max) {
      throw new Error(`Translation error: value out of range [${min}..${max}]`);
    }

    // Get the raw integer bits of the float
    const raw = new Float32Array([value])[0];
    const rawInt = new DataView(new ArrayBuffer(4));
    rawInt.setFloat32(0, raw);

    // Extract bytes from raw integer representation and return as Uint8Array
    return new Uint8Array([
      (rawInt.getInt32(0) >>> 24) & 0xff,
      (rawInt.getInt32(0) >>> 16) & 0xff,
      (rawInt.getInt32(0) >>> 8) & 0xff,
      rawInt.getInt32(0) & 0xff,
    ]);
  }

  static fromDPT14_4ByteFloat(bytes: Uint8Array): number {
    if (bytes.length !== 4) {
      throw new Error("Invalid byte length for DPT14: expected 4 bytes");
    }

    // Combine the 4 bytes into a 32-bit integer
    const intVal = (bytes[0] << 24) | (bytes[1] << 16) | (bytes[2] << 8) | bytes[3];

    // Create a DataView to interpret it as float
    const buffer = new ArrayBuffer(4);
    const view = new DataView(buffer);
    view.setInt32(0, intVal); // Use setInt32 to match signed bit pattern

    return view.getFloat32(0);
  }

  ///////////////////////////////////////
  // DPT-16: String

  // DPT_STRING_ASCII = new DPT("16.000", "ASCII string", "", "");
  // DPT_STRING_8859_1 = new DPT("16.001", "ISO-8859-1 string (Latin 1)", "", "");

  // Example : toDpt("Hello World", 0, "16.001");
  static toDpt16_String(buf, offset, dpt) {
    const stringLength = 14;

    let rangeMax = 0x7f; // Default to ASCII 7-bit encoding
    if (dpt === "16.001") {
      rangeMax = 0xff; // ISO-8859-1
    }

    const len = buf.length - offset;
    if (len % stringLength !== 0) {
      throw new Error("Data length " + len + " does not exactly fit KNX strings of length 14 bytes");
    }

    const items = len / stringLength;
    if (items === 0) {
      throw new Error("Data length " + len + " < required 14 bytes for KNX string");
    }

    const data = new Array(items * stringLength);

    // Process the buffer
    for (let i = 0; i < data.length; ++i) {
      const c = buf[offset + i];
      data[i] = c <= rangeMax ? c : 0x3f; // Replace with 0x3f if out of range (ASCII '?')
    }

    return data;
  }

  static fromDpt16_String(data: number[], dpt: string): Uint8Array {
    const stringLength = 14;

    if (data.length % stringLength !== 0) {
      throw new Error("Input data length must be a multiple of 14");
    }

    let rangeMax = 0x7f; // ASCII 7-bit encoding by default
    if (dpt === "16.001") {
      rangeMax = 0xff; // ISO-8859-1
    }

    const buf = new Uint8Array(data.length);

    for (let i = 0; i < data.length; ++i) {
      const c = data[i];
      if (c > rangeMax) {
        throw new Error(`Character code ${c} exceeds allowed range for DPT ${dpt}`);
      }
      buf[i] = c;
    }

    return buf;
  }

  ///////////////////////////////////////
  // DPT-17: Scene Number
  // DPT_SCENE_NUMBER = new DPT("17.001", "Scene Number", "0", "63");

  // Example: "learn 42"
  static toDpt17_SceneNumber(value) {
    const tokens = value.split(/\s+/); // Split by spaces or tabs
    if (tokens.length < 2) {
      throw new Error("wrong value format");
    }

    let learn = false;
    let s = tokens[0];
    if (s === "learn") {
      learn = true;
    } else if (s !== "activate") {
      throw new Error("wrong value format");
    }

    try {
      s = tokens[1];
      const scene = parseInt(s, 10); // Parse the second token as an integer
      if (scene < 0 || scene > 63) {
        throw new Error("input scene number out of range [0..63]");
      }
      return new Uint8Array(learn ? scene | 0x80 : scene); // Set MSB if learn
    } catch (e) {
      throw new Error("parsing error");
    }
  }

  static fromDpt17_SceneNumber(data: Uint8Array): string {
    if (data.length !== 1) {
      throw new Error("Input must be a Uint8Array of length 1");
    }

    const byte = data[0];
    const learn = (byte & 0x80) !== 0; // Check MSB
    const scene = byte & 0x3f; // Lower 6 bits

    if (scene < 0 || scene > 63) {
      throw new Error("Scene number out of valid range [0..63]");
    }

    return (learn ? "learn " : "activate ") + scene.toString();
  }

  ///////////////////////////////////////
  // DPT-18: Scene Control
  // DPT_SCENE_CONTROL = new DPT("18.001", "Scene Control", "activate 0", "learn 63");

  ///////////////////////////////////////
  // DPT-19: DateTime
  // DPT_DATE_TIME = new DPT("19.001", "Date with time", "1900/01/01 00:00:00", "2155/12/31 24:00:00", "yr/mth/day hr:min:sec");

  // Example: "2023-12-31 23:59:59 sync daylight workday"
  static toDPT19_DateTime(value) {
    const NO_WD = 0x10,
      NO_YEAR = 0x20,
      NO_DATE = 0x40,
      NO_DOW = 0x80,
      NO_TIME = 0x100;
    const YEAR = 0,
      MONTH = 1,
      DAY = 2,
      DOW = 3,
      HOUR = 4,
      MINUTE = 5,
      SECOND = 6;
    const DST = 0x01,
      WD = 0x02,
      QUALITY = 0x04,
      MIN_YEAR = 1990,
      MAX_YEAR = 2089;
    const DAYLIGHT_SIGN = "daylight",
      WORKDAY_SIGN = "workday",
      HOLIDAY_SIGN = "holiday",
      SYNC_SIGN = "sync";

    // Initialize dst array, 8 fields per index
    const dst = new Uint8Array(8);
    dst[6] = NO_WD | NO_YEAR | NO_DATE | NO_DOW | NO_TIME;

    const tokens = value.split(/[-:/\s(),]+/).filter((token) => token);

    let sync = 0,
      day = 0,
      workingDay = 0;
    const numbers: number[] = [];
    let count = 0;

    tokens.forEach((token) => {
      // Try to parse the token as a number
      const parsedValue = parseInt(token, 10);

      if (!isNaN(parsedValue)) {
        // If within year range, set the YEAR field
        if (parsedValue >= MIN_YEAR && parsedValue <= MAX_YEAR) {
          set(dst, YEAR, parsedValue - MIN_YEAR);
          setBit(dst, NO_YEAR, false);
        } else {
          numbers.push(parsedValue);
          count++;
        }
      } else {
        // Handle specific words such as "daylight", "workday", "holiday"
        const lowerToken = token.toLowerCase();
        if (lowerToken === DAYLIGHT_SIGN) {
          setBit(dst, DST, true);
        } else if (lowerToken === WORKDAY_SIGN || lowerToken === HOLIDAY_SIGN) {
          if (++workingDay > 1) throw new Error("Duplicate working day info");
          setBit(dst, NO_WD, false);
          setBit(dst, WD, lowerToken === WORKDAY_SIGN);
        } else if (lowerToken === SYNC_SIGN) {
          if (++sync > 1) throw new Error("Duplicate sync flag");
          setBitEx(dst, QUALITY, true);
        } else if (++day === 1) {
          const dow = getDayOfWeek(lowerToken);
          if (dow !== -1) {
            set(dst, DOW, dow);
            setBit(dst, NO_DOW, false);
          } else {
            throw new Error("Invalid day of week");
          }
        } else {
          throw new Error("Unrecognized date/time component");
        }
      }
    });

    if (count === 0) return dst;
    if (count === 1 || count === 4) throw new Error("Ambiguous date/time");

    let field = count === 3 ? HOUR : MONTH;
    if (field === HOUR || count === 5) setBit(dst, NO_TIME, false);
    if (field === MONTH) setBit(dst, NO_DATE, false);

    numbers.forEach((num, i) => set(dst, field + i, num));

    return dst;

    // Helper functions
    function set(dst, field, value) {
      checkRange(field, value);
      const i = field;
      if (field === YEAR) {
        dst[i] = value;
      } else if (field === DOW) {
        dst[i - 3] = (value << 5) | (dst[i - 3] & 0x1f);
      } else if (field === HOUR) {
        dst[i] = value | (dst[i] & 0xe0);
      } else {
        dst[i] = value;
      }
    }

    function setBit(dst, mask, bit) {
      if (bit) dst[6] |= mask;
      else dst[6] &= ~mask;
    }

    function setBitEx(dst, mask, bit) {
      if (bit) dst[7] |= mask;
      else dst[7] &= ~mask;
    }

    function checkRange(field, value) {
      const range = {
        [YEAR]: [0, 99],
        [MONTH]: [1, 12],
        [DAY]: [1, 31],
        [DOW]: [1, 7],
        [HOUR]: [0, 23],
        [MINUTE]: [0, 59],
        [SECOND]: [0, 59],
      };
      const [min, max] = range[field] || [];
      if (value < min || value > max) throw new Error(`Value out of range for field ${field}: ${value}`);
    }

    function getDayOfWeek(token) {
      const days = ["mon", "tue", "wed", "thu", "fri", "sat", "sun"];
      return days.findIndex((day) => day.startsWith(token.slice(0, 3))) + 1;
    }
  }

  static fromDPT19_DateTime(dst: Uint8Array): string {
    if (!(dst instanceof Uint8Array) || dst.length !== 8) {
      throw new Error("Input must be a Uint8Array of length 8");
    }

    const NO_WD = 0x10,
      NO_YEAR = 0x20,
      NO_DATE = 0x40,
      NO_DOW = 0x80,
      NO_TIME = 0x100;
    const YEAR = 0,
      MONTH = 1,
      DAY = 2,
      DOW = 3,
      HOUR = 4,
      MINUTE = 5,
      SECOND = 6;
    const DST = 0x01,
      WD = 0x02,
      QUALITY = 0x04,
      MIN_YEAR = 1990,
      MAX_YEAR = 2089;

    function isBitSet(mask: number): boolean {
      if (mask < 0x100)
        return (dst[6] & mask) !== mask; // inverted logic for NO_x flags
      else return (dst[7] & (mask & 0xff)) !== 0;
    }

    // Helper to extract the DOW (day of week) from dst[0] high 3 bits
    function getDOW(): number | null {
      // If NO_DOW flag is set, no DOW present
      if ((dst[6] & NO_DOW) !== 0) return null;
      return (dst[0] >> 5) & 0x07; // 3 bits for DOW
    }

    // Extract year if available
    const yearAvailable = (dst[6] & NO_YEAR) === 0;
    const year = yearAvailable ? dst[YEAR] + MIN_YEAR : null;

    // Extract date if available
    const dateAvailable = (dst[6] & NO_DATE) === 0;
    const day = dateAvailable ? dst[DAY] : null;
    const month = dateAvailable ? dst[MONTH] : null;

    // Extract time if available
    const timeAvailable = (dst[6] & NO_TIME) === 0;
    const hour = timeAvailable ? dst[HOUR] & 0x1f : null; // lower 5 bits for hour
    const minute = timeAvailable ? dst[MINUTE] : null;
    const second = timeAvailable ? dst[SECOND] : null;

    // Daylight saving flag
    const daylight = (dst[6] & DST) !== 0;

    // Workday flag (only valid if NO_WD is not set)
    const wdAvailable = (dst[6] & NO_WD) === 0;
    let workdayStr = "";
    if (wdAvailable) {
      workdayStr = (dst[6] & WD) !== 0 ? "workday" : "holiday";
    }

    // Sync quality flag
    const sync = (dst[7] & QUALITY) !== 0;

    // Day of week string
    const days = ["mon", "tue", "wed", "thu", "fri", "sat", "sun"];
    const dowNum = getDOW();
    const dowStr = dowNum ? days[dowNum - 1] : null;

    // Compose output string
    const parts: string[] = [];

    if (year !== null) parts.push(year.toString());
    if (month !== null) parts.push(month.toString());
    if (day !== null) parts.push(day.toString());
    if (dowStr !== null) parts.push(dowStr);
    if (timeAvailable) {
      parts.push(
        (hour !== null ? hour.toString().padStart(2, "0") : "00") +
          ":" +
          (minute !== null ? minute.toString().padStart(2, "0") : "00") +
          ":" +
          (second !== null ? second.toString().padStart(2, "0") : "00"),
      );
    }
    if (daylight) parts.push("daylight");
    if (workdayStr) parts.push(workdayStr);
    if (sync) parts.push("sync");

    return parts.join(" ");
  }

  ///////////////////////////////////////
  // DPT-28: UTF-8
  // DPT_UTF8 = new DPT("28.001", "UTF-8", "", "");

  static toDPT28_Utf8(value, dst, index) {
    const maxLength = 1024 * 1024;
    const utfdata = toUtf8(value, maxLength);

    // Find the offset based on the index
    // const dst = new Uint8Array(maxLength * 10); // Allocate a large enough buffer for all strings
    const offset = findOffsetFor(index, dst);

    // Copy UTF-8 data to the destination array
    for (let i = 0; i < utfdata.length; i++) {
      dst[offset + i] = utfdata[i];
    }

    // Ensure the string is null-terminated
    if (utfdata.length === 0 || utfdata[utfdata.length - 1] !== 0) {
      dst[offset + utfdata.length] = 0;
    }

    return dst;

    // Helper function to convert the string to a UTF-8 byte array
    function toUtf8(value, maxLength) {
      const utfdata = new TextEncoder().encode(value);
      if (utfdata.length > maxLength - 1) {
        throw new Error(`UTF-8 string exceeds translator limit of ${maxLength} bytes`);
      }
      return utfdata;
    }

    // Helper function to find the offset based on the index
    function findOffsetFor(index, dst) {
      let offset = 0;
      let idx = index;

      // Loop through the array to find the correct offset
      while (idx > 0) {
        if (offset >= dst.length) {
          throw new Error(`Index ${index} past last string`);
        }
        if (dst[offset] === 0) {
          idx--;
        }
        offset++;
      }

      return offset;
    }
  }

  static fromDPT28_Utf8(dst: Uint8Array, index: number): string {
    // Helper function to find the offset for the given index (same as original)
    function findOffsetFor(index: number, dst: Uint8Array): number {
      let offset = 0;
      let idx = index;

      while (idx > 0) {
        if (offset >= dst.length) {
          throw new Error(`Index ${index} past last string`);
        }
        if (dst[offset] === 0) {
          idx--;
        }
        offset++;
      }
      return offset;
    }

    const offset = findOffsetFor(index, dst);

    // Find the null terminator starting from offset
    let end = offset;
    while (end < dst.length && dst[end] !== 0) {
      end++;
    }

    // Extract bytes for this UTF-8 string slice
    const utf8slice = dst.subarray(offset, end);

    // Decode UTF-8 bytes to string
    return new TextDecoder().decode(utf8slice);
  }

  ///////////////////////////////////////
  // DPT-29: Electrical Energy - 64 Bit Signed

  // DPT_ACTIVE_ENERGY = new DPT("29.010", "Active Energy", "-9223372036854775808", "9223372036854775807", "Wh");
  // DPT_APPARENT_ENERGY = new DPT("29.011", "Apparent energy","-9223372036854775808", "9223372036854775807", "VAh");
  // DPT_REACTIVE_ENERGY = new DPT("29.012", "Reactive energy","-9223372036854775808", "9223372036854775807", "VARh");

  // Input: number
  static toDPT29_64BitSigned(value) {
    const result = new Uint8Array(8);
    result[0] = (value >> 56) & 0xff;
    result[1] = (value >> 48) & 0xff;
    result[2] = (value >> 40) & 0xff;
    result[3] = (value >> 32) & 0xff;
    result[4] = (value >> 24) & 0xff;
    result[5] = (value >> 16) & 0xff;
    result[6] = (value >> 8) & 0xff;
    result[7] = value & 0xff;
    return result;
  }

  static fromDPT29_64BitSigned(buf: Uint8Array): bigint {
    if (buf.length !== 8) {
      throw new Error("Buffer length must be 8 bytes");
    }

    let value = BigInt(0);
    for (let i = 0; i < 8; i++) {
      value = (value << BigInt(8)) | BigInt(buf[i]);
    }

    // Convert from unsigned to signed 64-bit integer
    if (value & (BigInt(1) << BigInt(63))) {
      value = value - (BigInt(1) << BigInt(64));
    }

    return value;
  }

  ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  // Special DPT Types:

  ///////////////////////////////////////
  // DPT-229: Metering Value
  // DptMeteringValue = new DPT("229.001", "Metering Value", Integer.toString(Integer.MIN_VALUE),Integer.toString(Integer.MAX_VALUE));

  ///////////////////////////////////////
  // DPT-232:  RGB Color
  // DPT_RGB = new DPT("232.600", "RGB", "0 0 0", "255 255 255", "");

  static toDPT232_RGB(value) {
    // Initialize RGB values to -1, indicating unassigned values
    let r = -1,
      g = -1,
      b = -1;

    // Split the input string into tokens by "-" or " " delimiters
    const tokens = value.split(/[-\s]+/);
    const maxTokens = 3;

    try {
      tokens.forEach((colorComponent, index) => {
        if (index >= maxTokens) return; // Limit to max of 3 tokens (r, g, b)

        // Further split each component by ":"
        const subTokens = colorComponent.split(":");

        if (subTokens.length === 2) {
          // Case: component with ID (e.g., "r:255")
          const [componentID, componentValue] = subTokens;
          const parsedValue = parseInt(componentValue, 10);

          switch (componentID.trim().toLowerCase()) {
            case "r":
              r = parsedValue;
              break;
            case "g":
              g = parsedValue;
              break;
            case "b":
              b = parsedValue;
              break;
            default:
              throw new Error(`Invalid color component: ${componentID}`);
          }
        } else if (subTokens.length === 1) {
          // Case: single value without component prefix (e.g., "255-128-64")
          const parsedValue = parseInt(subTokens[0], 10);
          if (index === 0) r = parsedValue;
          else if (index === 1) g = parsedValue;
          else if (index === 2) b = parsedValue;
        } else {
          throw new Error("Expected component identifier (e.g., 'r:', 'g:', 'b:')");
        }
      });

      // Check if all color components were assigned valid values
      if (r === -1 || g === -1 || b === -1) {
        throw new Error("Invalid color: missing component(s)");
      }

      // Validate the range of RGB values (0 to 255)
      if (r < 0 || r > 255) throw new Error("Red value out of range [0..255]");
      if (g < 0 || g > 255) throw new Error("Green value out of range [0..255]");
      if (b < 0 || b > 255) throw new Error("Blue value out of range [0..255]");

      // Return the color as a Uint8Array
      return new Uint8Array([r, g, b]);
    } catch (e) {
      throw new Error(`Invalid color format: ${e}`);
    }
  }

  static fromDPT232_RGB(buf: Uint8Array): string {
    if (buf.length !== 3) {
      throw new Error("Input buffer length must be 3 bytes for RGB");
    }

    const [r, g, b] = buf;

    // Return string in the format "r:<value> g:<value> b:<value>"
    return `r:${r} g:${g} b:${b}`;
  }

  ///////////////////////////////////////
  // DPT-242: Color XyY
  // DptXyY = new DPT("242.600", "color xyY", "(0 0) 0", "(1 1) 100", "%");

  ///////////////////////////////////////
  // DPT-243: XyYTransition
  // DptXyYTransition = new DPT("243.600", "color transition xyY", "(0, 0) 0 % 0 ms", "(1, 1) 100 % 6553500 ms");

  ///////////////////////////////////////
  // DPT-249: Brightness & color temperature transition
  // DptBrightnessClrTempTrans = new DPT("249.600", "brightness & color temperature transition","0 0 0", "100 65535 6553.5", "% K s");

  ///////////////////////////////////////
  // DPT-250:  brightness & color temperature control;
  // DptBrightnessClrTempCtrl = new DPT("250.600", "brightness & color temperature control","decrease 1 decrease 1", "increase 7 increase 7");

  // Example: "K 3000 lx 200",0
  static toDPT250_BrightnessAndColorTemp(value, index) {
    // Define the suffixes and the valid range check
    const clrTempSuffix = "K"; // Assuming color temperature is represented by "K"
    const brightnessSuffix = "lx"; // Assuming brightness is represented by "lx"
    const maxFields = 8;
    const minFields = 2;

    if (value === "") return new Uint8Array(3); // Return empty array if input is empty

    const fields = value.split(" ");

    // Check for valid number of fields
    if (fields.length > maxFields || fields.length < minFields)
      throw new Error("unsupported format for brightness & color temperature control");

    let valid = 0;
    const offset = index * 3; // offset in the Uint8Array for each value
    let i = 0;
    let result = new Uint8Array(3);

    // Process color temperature and brightness based on the fields
    if (fields[i] === clrTempSuffix) {
      const clr = component(true, fields, ++i);
      valid |= clr === 0 ? 0 : 2;
      result[offset] = clr;

      i += clr === 0 ? 1 : 2;
      if (fields[i] === "steps") i++;

      if (fields[i] !== brightnessSuffix) throw new Error("no brightness");
      i++;

      const brt = component(false, fields, i);
      valid |= brt === 0 ? 0 : 1;
      result[offset + 1] = brt;
      i += brt === 0 ? 1 : 2;
      if (i < fields.length && fields[i] === "steps") i++;
    } else if (fields.length >= 2 && fields.length <= 6) {
      const clr = component(true, fields, i);
      valid |= clr === 0 ? 0 : 2;
      result[offset] = clr;

      i += clr === 0 ? 1 : 2;
      if (fields[i] === "steps") i++;

      const brt = component(false, fields, i);
      valid |= brt === 0 ? 0 : 1;
      result[offset + 1] = brt;
      i += brt === 0 ? 1 : 2;
      if (i < fields.length && fields[i] === "steps") i++;
    }

    if (i < fields.length) throw new Error("value contains excessive components");

    result[offset + 2] = valid; // Validity byte
    return result;

    function component(color, fields, i) {
      const first = fields[i];
      if (first === "-") return 0; // If the field is "-", return 0
      const value = first + " " + fields[i + 1];
      return parseInt(value); // Simulating the `setValue` logic and returning the numeric part
    }
  }

  static fromDPT250_BrightnessAndColorTemp(buf, index) {
    const offset = index * 3;
    if (buf.length < offset + 3) {
      throw new Error("Buffer too short for given index");
    }

    const clr = buf[offset]; // Color temperature value
    const brt = buf[offset + 1]; // Brightness value
    const valid = buf[offset + 2]; // Validity byte

    // If both values are zero and validity indicates none valid, return empty string
    if (clr === 0 && brt === 0 && valid === 0) return "";

    const parts: string[] = [];

    // If color temperature is valid (bit 1 set), include it
    if ((valid & 2) !== 0) {
      if (clr === 0) {
        parts.push("-"); // Represent missing value by "-"
      } else {
        parts.push("K", clr.toString());
        parts.push("steps");
      }
    }

    // If brightness is valid (bit 0 set), include it
    if ((valid & 1) !== 0) {
      if (brt === 0) {
        parts.push("-"); // Represent missing value by "-"
      } else {
        parts.push("lx", brt.toString());
        parts.push("steps");
      }
    }

    return parts.join(" ");
  }

  ////////////////////////////////////////
  // DPT-251: Color Rgbw
  // DptRgbw = new DPT("251.600", "RGBW color", "0 0 0 0", "100 100 100 100", "%");

  ////////////////////////////////////////
  // DPT-252: RelativeControlRgbw
  // DptRelativeControlRgbw = new DPT("252.600", "relative control RGBW", "R decrease 0 G decrease 0 B decrease 0 W decrease 0", "R increase 7 G increase 7 B increase 7 W increase 7");

  ////////////////////////////////////////
  // DPT-253: RelativeControlXyY
  // DptRelativeControlXyY = new DPT("253.600", "relative control xyY", "x decrease 0 y decrease 0 Y decrease 0", "x increase 7 y increase 7 Y increase 7");

  ////////////////////////////////////////
  // DPT-254: RelativeControlRgb
  // DptRelativeControlRgb = new DPT("254.600", "relative control RGB", "decrease 0 decrease 0 decrease 0", "increase 7 increase 7 increase 7");
}
